'use strict';

(function () {
    'use strict';

    angular.module('damages.docsInsurer', ['ui.router', 'common']);
})();